<template>
  <div>
    <Etapa/>
  </div>
</template>
<script>
import Etapa from '../paseodelparque/mapLocation/Etapa'
export default {
  name: "EtapaMenu",
  components: {
    Etapa
  }
}
</script>
<style scoped>
</style>